import { blacklistEmailDomains } from 'shared/constants/blacklist-email-domains'

export const isBlacklistEmailDomain = (email: string) => {
  const domain = email.split('@')[1]
  return domain ? blacklistEmailDomains.includes(domain) : false
}
